import { FULL_WIDTH_MODE } from '@atlaskit/editor-common/analytics';
export var formatFullWidthAppearance = function formatFullWidthAppearance(appearance) {
  if (appearance === 'full-width') {
    return FULL_WIDTH_MODE.FULL_WIDTH;
  }
  return FULL_WIDTH_MODE.FIXED_WIDTH;
};